import { computed } from "@vue/composition-api";
import moment from "moment";
const time = moment("2022-10-17", "YYYY-MM-DD");
const today = moment(Date.now()).format("YYYY-MM-DD");
const is_today_before_feature_release_date = time.isAfter(today);

const title = computed(() => {
  if (is_today_before_feature_release_date) {
    return `No Data Available Yet`;
  } else {
    return `No Data Available`;
  }
});

const msg = computed(() => {
  if (is_today_before_feature_release_date) {
    return `This is a new feature released on Oct 17th affecting only new data`;
  } else {
    return `We're upgrading our risk analysis.<br> As part of this planned upgrade, certain insights will only be available from Oct 17, 2022.
<br>To review your current insights, try checking the timeframe "This Week" in the top left corner.`;
  }
});

export const not_available = {
  title,
  msg,
};
